//System
import { Component, ChangeDetectionStrategy, ViewEncapsulation, OnInit, ViewContainerRef, Compiler, Inject, Input } from '@angular/core';
import { Location } from '@angular/common';

//Services
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { CmsComponentService } from "./../../../../services/cms/cms-component.service";
import { CompanyService } from "./../../../../services/core/company.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { AuthService } from './../../../../services/core/auth.service';
import { SysConfig } from "./../../../../services/core/system-configuration.service";
import { ShoppingCartService } from "./../../../../services/inventory/shopping-cart.service";
import { NodeLoggerService } from "./../../../../services/core/node-logger.service";

//Models
import { Mappings } from './../../../../shared/mapping';
import { Company } from "./../../../../models/core/company";
import { Template } from "./../../../../models/settings/template";
import { Menu } from "./../../../../models/cms/menu";
import { UserLogin } from "./../../../../models/cms/user-login";
import { SearchService } from '../../../../services/inventory/search.service';
import { Router, Params } from "@angular/router";
import { ActivatedRoute } from '@angular/router/src/router_state';
import { ApplicationService } from './../../../../services/core/application.service';
import { Subscription } from 'rxjs/Subscription';
import { CustomersCanvasService } from '../../../../services/inventory/customerscanvas.service';
import { HeaderService } from '../../../../services/cms/header.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector: "dy-header",
    template: ''
})

export class HeaderComponent implements OnInit {
    data: any = {};
    @Input() parentHeaderData: any;

    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private cmsComponentService: CmsComponentService,
            private nodeLogger: NodeLoggerService,
            @Inject('isBrowser') private isBrowser: boolean
        ) { }

    subManager = new Subscription();


    ngOnInit() {
        if(!this.isBrowser)
            return;
            
        if (this.parentHeaderData != null) {
            //Creating subcomponent whith the selected template to inject
            let subComponent = this.createSubComponent(this.parentHeaderData);

            //injecting created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }

        else {
            //let templateHtml: string;
            let headerInfo: any;

            //Instead of reading only the template, also the information to show are retrieved (eg. menu list)
            let headDataSub = this.cmsComponentService.getHeaderData().subscribe(result => {
                headerInfo = result;
                var startDate = new Date();

                //Creating subcomponent whith the selected template to inject
                let subComponent = this.createSubComponent(headerInfo);

                //injecting created component (OK)
                this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);

                var endDate = new Date();

                var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
                var diffMs = Math.ceil(timeDiff);

                this.nodeLogger.AddLogWithTime("injecting Header (" + diffMs + ")");
            });

            this.subManager.add(headDataSub);
        }
    }

    ngOnDestroy() {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        this.subManager.unsubscribe();
    }

    //Creates component to inject 
    private createSubComponent(headerInfo: any) {
        @Component({
            template: headerInfo.TemplateHtml
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private language: LanguageService,
                    private routeService: RoutesService,
                    private authService: AuthService,
                    private cartService: ShoppingCartService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private searchService: SearchService,
                    private routesService: RoutesService,
                    private router: Router,
                    protected appService: ApplicationService,
                    private activatedRoute: ActivatedRoute,
                    public canvasService: CustomersCanvasService,
                    private headerService: HeaderService
                ) {
                this.cartService.initCart(headerInfo.CartInfo);
                this.headerService.getLoggedInUser().subscribe((user: UserLogin | null) => {
                    this.loggedIdUser = user;
                });
            }

            private headerIsInit: boolean = false;

            private company: Company = headerInfo.Company;
            private menuItems: Array<Menu> = headerInfo.MenuList;
            private megaMenuItems: any = headerInfo.Categories;
            public isActiveQuickRegistration: boolean = headerInfo.IsActiveQuickRegistration;
            public quickRegistrationData: any = headerInfo.QuickRegistrationData;

            private languagesList: any[] = headerInfo.Languages;
            private currentLanguage: any = {};
            private loggedIdUser: UserLogin = new UserLogin();
            private shoppingCart: any = headerInfo.CartInfo;
            private homePageName: string[] = [];
            private productsPageName: string[] = [];
            private promotionsPageName: string[] = [];

            private loginPageName: string[] = [];
            private registerPageName: string[] = [];
            private areaClientiName: string[] = [];
            private carrelloPageName: string[] = [];
            private blogPageName: string[] = [];
            private contactPageName: string[] = [];
            private disableModalButtons: boolean = false;
            private spinner: boolean = false;
            private productId: any;
            private selectedProduct: any;

            subManager = new Subscription();

            ngOnInit() {
                var date = new Date();
                let lang: string = this.language.getShortLang();

                //Setting current language info
                for (let entry of this.languagesList) {
                    if (entry.ShortCode == lang) {
                        this.currentLanguage = entry;
                        break;
                    }
                }

                this.homePageName = this.routeService.getRoutePath('HOME');
                this.productsPageName = this.routeService.getRoutePath('CATALOGO PRODOTTI (HOME)');
                this.promotionsPageName = this.routeService.getRoutePath('CATALOGO - PRODOTTI IN OFFERTA');

                this.loginPageName = this.routeService.getRoutePath('LOGIN');
                this.registerPageName = this.routeService.getRoutePath('REGISTRAZIONE');
                this.areaClientiName = this.routeService.getRoutePath('AREA CLIENTI - STATISTICHE');
                this.carrelloPageName = this.routeService.getRoutePath('CARRELLO');
                this.blogPageName = this.routeService.getRoutePath('BLOG');
                this.contactPageName = this.routeService.getRoutePath('RICHIESTA INFORMAZIONI');

                //setup of links, they must start with http to work properly
                let linkStart = "http://";
                let linkSecuredStart = "https://";

                if (this.company.Facebook != null) {
                    if (this.company.Facebook.indexOf(linkStart) == -1 && this.company.Facebook.indexOf(linkSecuredStart) == -1) {
                        this.company.Facebook = linkStart + this.company.Facebook;
                    }
                }

                if (this.company.Youtube != null) {
                    if (this.company.Youtube.indexOf(linkStart) == -1 && this.company.Youtube.indexOf(linkSecuredStart) == -1) {
                        this.company.Youtube = linkStart + this.company.Youtube;
                    }
                }

                if (this.company.Twitter != null) {
                    if (this.company.Twitter.indexOf(linkStart) == -1 && this.company.Twitter.indexOf(linkSecuredStart) == -1) {
                        this.company.Twitter = linkStart + this.company.Twitter;
                    }
                }

                if (this.company.Website != null) {
                    if (this.company.Website.indexOf(linkStart) == -1 && this.company.Website.indexOf(linkSecuredStart) == -1) {
                        this.company.Website = linkStart + this.company.Website;
                    }
                }

                if (this.company.Instagram != null) {
                    if (this.company.Instagram.indexOf(linkStart) == -1 && this.company.Instagram.indexOf(linkSecuredStart) == -1) {
                        this.company.Instagram = linkStart + this.company.Instagram;
                    }
                }
            }


            showModal(product) {
                this.disableModalButtons = false;
                $("#headerModal").modal("show");
                this.productId = product.Id;
                this.selectedProduct = product;
            }


            hideModal() {
                $('#headerModal').modal('hide');
                this.disableModalButtons = true;
            }

            // customers canvas state module is active and current product has canvasStateId defined, then send a request to delete a state from customers canvas server
            removeCustomersCanvasState() {
                if (this.selectedProduct.isCanvasEdited && this.selectedProduct.CanvasStateId) {
                    const canvasConfigData = this.setCanvasConfig(this.selectedProduct);

                    this.canvasService.deleteCustomerCanvasState(canvasConfigData)
                        .subscribe(x => x,
                            err => {
                                console.log(err);
                            });
                }
            }

            setCanvasConfig(product) {
                const canvasConfigData = {
                    CanvasUrl: headerInfo.CanvasInfo.CanvasUrl,
                    CustomerCanvasUserName: headerInfo.CanvasInfo.CustomerCanvasUserName,
                    CanvasStateId: product.CanvasStateId,
                    CanvasApiKey: headerInfo.CanvasInfo.ApiKey
                };

                return canvasConfigData;
            }

            //Redirect the user to the homepage for the selected language
            setLanguage(lang) {
                window.location.href = "/" + lang + '/home';
            }

            logout() {
                this.authService.Logout();
            }

            removeFromCart() {
                this.spinner = true;
                this.disableModalButtons = true;
                let removeCartSub = this.cartService.removeFromCart(this.productId).subscribe(result => {
                    this.cartService.updateCart(result);
                    this.shoppingCart = this.cartService.getCart();
                    this.removeCustomersCanvasState();

                    this.hideModal();
                    this.spinner = false;
                });

                this.subManager.add(removeCartSub);
            }

            //getting value of search input and redirecting to search result page
            getSearchResults(inputVal) {
                let query = "";
                inputVal = inputVal.trim();

                if (inputVal == "") {
                    return;
                }
                else {
                    this.searchService.setQueryPlainTextValue(inputVal);

                    if (inputVal != undefined) {
                        query = inputVal;
                    }
                    else {
                        let subParam = this.activatedRoute.params.subscribe((params: Params) => {
                            let encodedQuery = params['query'];
                            query = decodeURIComponent(encodedQuery);
                        })

                        this.subManager.add(subParam);

                    }
                }

                query = decodeURIComponent(query);
                let uriString = encodeURIComponent(query);

                this.searchService.setQueryValue(uriString);

                let searchRoute = this.routesService.getRoutePath('SEARCH - RESULTS')[0];
                searchRoute = searchRoute.replace(":query", query);

                this.router.navigate([searchRoute]);
            }
            setAutoHeightAndWeightToLogo() {
                let headerClass = $("div").hasClass("header-logo");
                if (headerClass == false) {
                    setTimeout(x => this.setAutoHeightAndWeightToLogo(), 300);
                }
                else {
                    $(".header-logo").attr("style", "height:auto!important");
                    $(".header-logo").attr("style", "width:auto!important");
                }
            }
            ngAfterViewChecked() {
                var date = new Date();

                if (!this.isBrowser || this.headerIsInit) {
                    return;
                }

                //setting value of search textbox to search condition value if the current page is search-result page, else, clean it's content
                let documentUrl = window.location.href;

                if (documentUrl.indexOf("search-results") != -1) {
                    var plainSearchText = this.searchService.getQueryPlainTextValue();
                    if (plainSearchText != "") {
                        $("#searchQuery").val(plainSearchText);
                    }
                    else {
                        this.activatedRoute.params.subscribe((params: Params) => {
                            let encodedQuery = params['query'];

                            var decodedQuery = decodeURIComponent(encodedQuery)
                            $("#searchQuery").val(decodedQuery);
                        })
                    }
                }
                else {
                    $("#searchQuery").val("");
                }

                $("#searchQuery").keyup(function (event) {
                    if (event.keyCode === 13) {
                        $("#searchQueryButton").click();
                    }
                });


                layoutTheme.initNavMenu();
                layoutTheme.initStickyHeader();
                let config = this.appService.getConfig();
                if (config.webStoreStatus == "offline") {
                    this.setAutoHeightAndWeightToLogo();
                }
                this.headerIsInit = true;
            }

            ngOnDestroy() {
                //Called once, before the instance is destroyed.
                //Add 'implements OnDestroy' to the class.
                this.subManager.unsubscribe();
            }
        }

        return ChildComponent;
    }
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/cms/header/widget/header.component.ts